// Removed temporarily based on this ticket https://opensooq.atlassian.net/browse/OS-4953
import { getCustomThemeValue } from "helpers/osHelpers";

export const PRIORITIZED_SERVICES: AdServices[] =
  getCustomThemeValue("AdServices");

export type MobileAdAliases = keyof typeof nameAliases["mobile"];
export type DesktopAdAliases = keyof typeof nameAliases["desktop"];
export type AdServices = "google";

interface IGetAdsConfigsParams {
  device: "mobile" | "desktop";
  adName: MobileAdAliases | DesktopAdAliases;
  forceService?: AdServices;
  isFixed?: boolean;
}

export interface IAdConfig {
  serviceInfo: { networkId: string; service: AdServices };
  adDetails: {
    adUnit: string;
    "data-aa-adunit": string;
    sizes: ([number, number] | "fluid")[];
    id: string;
    isVideo?: boolean;
    disableInitialLoad?: boolean;
  };
}

const google = {
  networkId: "22729315574,1082751",
  mobile: {
    slots: {
      "OpenSooq_Oman/MPU": {
        id: "1701249756021-0",
        sizes: [[300, 250]]
      }
    },
  },
  desktop: {
    slots: {
      OpenSooq_FoxPush_Sticky_SA: {
        id: "gpt-passback",
        sizes: [[300, 250]]
      },
      OpenSooq_FoxPush_Sticky_Oman: {
        id: "gpt-passback",
        sizes: [[300, 250]]
      },
      OpenSooq_FoxPush_Sticky_KW: {
        id: "gpt-passback",
        sizes: [[300, 250]]
      },
      OpenSooq_FoxPush_Sticky_BH: {
        id: "gpt-passback",
        sizes: [[300, 250]]
      },
      OpenSooq_FoxPush_Sticky_QA: {
        id: "gpt-passback",
        sizes: [[300, 250]]
      },
      OpenSooq_FoxPush_Sticky_AE: {
        id: "gpt-passback",
        sizes: [[300, 250]]
      },
      "OpenSooq_Oman/OpenSooq_Oman_LBBB": {
        id: "1701249681321-0",
        sizes: [[728, 90]]
      }
    },
  },
};

const adConfigs = {
  google,
};

const nameAliases = {
  mobile: {
    "OpenSooq_Oman/MPU": {
      google: "OpenSooq_Oman/MPU",
    },
  },
  desktop: {
    OpenSooq_FoxPush_Sticky_SA: {
      google: "OpenSooq_FoxPush_Sticky_SA",
    },
    OpenSooq_FoxPush_Sticky_Oman: {
      google: "OpenSooq_FoxPush_Sticky_Oman",
    },
    OpenSooq_FoxPush_Sticky_KW: {
      google: "OpenSooq_FoxPush_Sticky_KW",
    },
    OpenSooq_FoxPush_Sticky_BH: {
      google: "OpenSooq_FoxPush_Sticky_BH",
    },
    OpenSooq_FoxPush_Sticky_QA: {
      google: "OpenSooq_FoxPush_Sticky_QA",
    },
    OpenSooq_FoxPush_Sticky_AE: {
      google: "OpenSooq_FoxPush_Sticky_AE",
    },
    "OpenSooq_Oman/OpenSooq_Oman_LBBB": {
        google: "OpenSooq_Oman/OpenSooq_Oman_LBBB",
    }
  },
};

export function getAdInfo({
  device,
  adName,
  forceService,
  isFixed = true,
}: IGetAdsConfigsParams): IAdConfig {
  const { adOriginalName, service } =
    getValidAdWhileConsideringServicePriority(forceService);

  const { networkId } = adConfigs[service];

  const data = adConfigs[service][device].slots[adOriginalName];
  // (function handleOtherAdsWithNoIds(currentAdName) {
  //   const adsWithNoIds = {
  //     "autosServicesTop-desktop": "1x1-autosServicesTop-desktop",
  //     "autosServicesTop-mobile": "1x1-autosServicesTop-mobile",
  //   };
  //   if (!adOriginalName) {
  //     return;
  //   }
  //   const adNewId = adsWithNoIds[currentAdName];
  //   const adNameInConfig = nameAliases[device][currentAdName][service];
  //
  //   if (adNewId) {
  //     data.id = adNewId;
  //     return;
  //   }
  //
  //   if (adNameInConfig) {
  //     data.id = adConfigs[service][device].slots[adNameInConfig].id;
  //   }
  // })(adName);

  function getValidAdWhileConsideringServicePriority(
    forceService?: AdServices
  ) {
    let service = PRIORITIZED_SERVICES[0];
    const adOriginalNameObject = nameAliases[device][adName];
    if (!adOriginalNameObject) {
      return { adOriginalName: null, service: service };
    }
    let adOriginalName: string;

    if (forceService)
      return {
        adOriginalName: adOriginalNameObject[forceService],
        service: forceService,
      };

    for (let currentService of PRIORITIZED_SERVICES) {
      if (!adOriginalNameObject[currentService]) break;
      else {
        service = currentService;
        adOriginalName = adOriginalNameObject[service];
        break;
      }
    }
    return { adOriginalName, service };
  }

  return {
    serviceInfo: { networkId, service },
    adDetails: {
      adUnit: adOriginalName,
      "data-aa-adunit": isFixed ? `/${networkId}/OpenSooq/OpenSooq_Sticky_MPU/${adOriginalName}` : `/${networkId}/OpenSooq/${adOriginalName}`,
      ...data,
    },
  };
}
